"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var index_1 = require("../index");
var MessageScreenTemplate = function (props) {
    var action = props.action, children = props.children, header = props.header, imageUrl = props.imageUrl, subHeader = props.subHeader;
    var isCDS = false; // Adding flag to preserve CDS components
    return (React.createElement("section", { className: classNames("oui-width-1-1", {
            "oui-text-center": isCDS,
            "oui-flex oui-flex-center": !isCDS
        }) },
        React.createElement("div", null,
            " ",
            isCDS && imageUrl && React.createElement("img", { src: imageUrl }),
            React.createElement("div", null, isCDS ? (React.createElement("h1", null,
                React.createElement("em", null, header))) : (React.createElement("strong", null, header))),
            isCDS && subHeader && (React.createElement("h2", { className: "oui-h1 oui-margin-large-bottom" }, subHeader)),
            children,
            isCDS && action && (React.createElement("div", { className: "oui-margin-large-top" },
                React.createElement(index_1.Button, { onClick: action.onClick, buttonSize: index_1.ButtonSize.Default, buttonStyle: index_1.ButtonStyle.Primary }, action.text))))));
};
exports.default = MessageScreenTemplate;
//# sourceMappingURL=MessageScreenTemplate.js.map